
// window.addEventListener("load", function () {
//   setTimeout(function () {
//     // Remove drawer open class
//     document
//       .querySelector(".page-wrapper")
//       ?.classList.remove("page-wrapper--drawer-open");

//     // Close the drawer
//     const drawer = document.querySelector(
//       ".theme-drawer__dialog.color-custom-drawer"
//     );

//     if (drawer) {
//       drawer.removeAttribute("open");
//       // Agar browser support karta ho to dialog ko properly close bhi kar do
//       if (typeof drawer.close === "function") {
//         try {
//           drawer.close();
//         } catch (e) {}
//       }
//     }

//     // Remove inline style from #cart-drawer
//     const cartDrawer = document.querySelector("#cart-drawer");
//     if (cartDrawer) {
//       cartDrawer.style.removeProperty("--drawer-stack-order");

//       // Agar sirf yehi inline style hai to pura style attribute bhi remove kar do
//       if (!cartDrawer.getAttribute("style")?.trim()) {
//         cartDrawer.removeAttribute("style");
//       }
//     }
//   }, 100);
// });


  document.addEventListener('DOMContentLoaded', function () {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    const dialog = drawer.querySelector('dialog[ref="panel"]');
    if (dialog && dialog.open) {
      dialog.close();
    }
    document.body.classList.remove('overflow-hidden', 'scroll-lock', 'js-drawer-open');
  });



window.addEventListener("load", function () {

    // tabs sections

    function initTabs(wrapper) {

        const tabs = document.querySelectorAll(`${wrapper} .tab-btn`);
        const contents = document.querySelectorAll(`${wrapper} .tab-content`);

        tabs.forEach(tab => {
            tab.addEventListener("click", function () {

                tabs.forEach(btn => btn.classList.remove("active"));
                this.classList.add("active");

                contents.forEach(content => content.classList.remove("active"));

                const target = document.getElementById(this.dataset.tab);
                if (target) target.classList.add("active");

            });
        });

    }

    initTabs(".product-tabs");
    initTabs(".benefit-tabs");




    // product scroller

   if (window.matchMedia("(min-width: 600px)").matches) {

    document.querySelectorAll('.cstm-product-crousel').forEach(carousel => {

        carousel.insertAdjacentHTML(
            'beforeend',
            `
            <button class="scroll-left">❮</button>
            <button class="scroll-right">❯</button>
            `
        );

        const scroller = carousel.querySelector('.group-block-content');

        carousel.querySelector('.scroll-left').onclick = () => {
            scroller.scrollBy({ left: -350, behavior: 'smooth' });
        };

        carousel.querySelector('.scroll-right').onclick = () => {
            scroller.scrollBy({ left: 350, behavior: 'smooth' });
        };

        function startAuto() {
            return setInterval(() => {
                // If at (or near) the end, go back to start; otherwise scroll right
                if (scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 5) {
                    scroller.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    scroller.scrollBy({ left: 350, behavior: 'smooth' });
                }
            }, 2000);
        }

        let autoScroll = startAuto();

        carousel.addEventListener('mouseenter', () => clearInterval(autoScroll));
        carousel.addEventListener('mouseleave', () => { autoScroll = startAuto(); });

    });
}



    document.querySelectorAll('.menu-list__submenu').forEach(submenu => {

        const parent = submenu.closest('.menu-list__item'); // apne parent selector ke hisab se change kar lo

        submenu.addEventListener('mouseenter', () => {
            if (parent) {
                parent.setAttribute('data-active', '');
            }
        });

        submenu.addEventListener('mouseleave', () => {
            if (parent) {
                parent.removeAttribute('data-active');
            }
        });

    });

});



